// extracted by mini-css-extract-plugin
module.exports = {"name":"Tradeline_name__1nVTq","amount":"Tradeline_amount__1_xiB"};